export function extractForenameSurname(name: string) {
    const [forename, ...otherNames] = name.split(' ')
    return { forename, surname: otherNames.join(' ') }
}

export function getInitials(name: string) {
    return name
        .trim()
        .split(/\s+/g)
        .filter((_, i, a) => i === 0 || i === a.length - 1)
        .map((s) => s[0])
        .join('')
        .toUpperCase()
}
